import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  searchSelect: {
    border: "#3f51b5",
    borderRadius: "5px",
    minWidth: theme.spacing(15),
  },
  searchFilterWrapper: {
    display: "flex",
    alignItems: "center",
    margin: "0.5rem 0rem",
    columnGap: "0.5rem",
    height: "65px",
    overflowX: "scroll",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
      width: "2px !important",
      height: "2px !important",
      cursor: "pointer",
      display: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#808080",
      width: "2px !important",
      borderRadius: "10px",
      display: "none",
    },
  },
  searchFieldSize: {
    minWidth: "205px",
    "& .MuiOutlinedInput-inputMarginDense": {
      paddingTop: "0.70rem",
      paddingTop: "0.70rem",
    },
    "& .MuiInputLabel-formControl": {
      fontSize: "0.8rem !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "0.8rem"
    }
  },
  forwardButton: {
    position: 'absolute',
    right: 0,
    top: '58%',
    transform: 'translateY(-50%)',
    "& .MuiSvgIcon-root": {
      padding: "0.2rem",
      background: "#8080804a",
      height: "auto",
      width: "18px",
      borderRadius: "100px",
      fontSize: "0.5rem",
      color: "black",
      cursor: "pointer",
      "& :hover": {
        background: "#808080",
        color: "#FFF"
      }
    }
  },
  backwardButton: {
    position: 'absolute',
    left: "-2%",
    top: '58%',
    transform: 'translateY(-60%)',
    zIndex: 1,
    "& .MuiSvgIcon-root": {
      padding: "0.2rem",
      background: "#8080804a",
      height: "auto",
      width: "18px",
      borderRadius: "100px",
      fontSize: "0.5rem",
      color: "black",
      cursor: "pointer",
      "& :hover": {
        background: "#808080",
        color: "#FFF"
      }
    }
  },
  dateRangeContainer: {
    columnGap: "0.3rem",
    marginRight: "0",
  }
}))

export default styles;